export enum ECtaParamType {
  NONE = 'NONE',
  POST_ID = 'POST_ID',
  ORDER_ID = 'ORDER_ID',
  CAMPAIGN_ID = 'CAMPAIGN_ID',
}

export type TCtaTargetOption = {
  slug: string
  label: string
  paramType: ECtaParamType
  example: string
}
